import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'it_CH',
  {
    fdidYouMean: true,
    ffacetNavigation: true,
    fdomainSuggestions: true,
    fvideo: true,
    fCommerceCarrossel: true,
    resultTiles: true,
    dealerWidget: false,
    frelatedsearch: true,
  },
  {
    fssInputCategory: true,
  },
  '05880230-595d-4574-954c-7844c366074b',
  ''
);
